import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { debounce } from '@cian/newbuilding-utils';
import { FILTER_DEBOUNCE_TIME } from '../constants/filter';
import { fetchLayouts } from '../services';
import { NewbuildingLayoutsContext } from '../shared/context';
import { mapOffersLink } from '../utils/mapOffersLink';
import { getFilterParams, setRoomQueryParams } from '../utils/queryStringHelper';
export var useLayouts = function useLayouts(_ref) {
  var newbuildingId = _ref.newbuildingId,
    isHouseLayoutsAvailable = _ref.isHouseLayoutsAvailable,
    houseId = _ref.houseId,
    isQueryParamsEnabled = _ref.isQueryParamsEnabled;
  var _React$useContext = React.useContext(NewbuildingLayoutsContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    roomType = _React$useState2[0],
    setRoomType = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    layouts = _React$useState4[0],
    setLayouts = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoading = _React$useState6[0],
    setIsLoading = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isError = _React$useState8[0],
    setIsError = _React$useState8[1];
  var _React$useState9 = React.useState(1),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    page = _React$useState10[0],
    setPage = _React$useState10[1];
  var _React$useState11 = React.useState(1),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    lastPage = _React$useState12[0],
    setLastPage = _React$useState12[1];
  var _React$useState13 = React.useState(),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    offersLinks = _React$useState14[0],
    setOffersLinks = _React$useState14[1];
  var loadLayouts = React.useCallback(function (params) {
    setIsLoading(true);
    setIsError(false);
    fetchLayouts({
      params: params,
      httpApi: httpApi,
      logger: logger
    }).then(function (layoutsInfo) {
      if (!layoutsInfo) {
        setIsLoading(false);
        setIsError(true);
        setLayouts([]);
        setRoomType([]);
        return;
      }
      setLayouts(layoutsInfo.fromDeveloperLayouts);
      setRoomType(layoutsInfo.filters.roomType);
      if (layoutsInfo.pagination) {
        setPage(layoutsInfo.pagination.page);
        setLastPage(layoutsInfo.pagination.lastPage);
      } else {
        setPage(1);
        setLastPage(1);
      }
      setOffersLinks(mapOffersLink(layoutsInfo));
      setIsLoading(false);
    });
  }, []);
  var loadLayoutsDebounced = React.useMemo(function () {
    return debounce(FILTER_DEBOUNCE_TIME, loadLayouts);
  }, []);
  React.useLayoutEffect(function () {
    if (!isHouseLayoutsAvailable) {
      setIsLoading(false);
      setLayouts([]);
      return;
    }
    var queryFilterParams = getFilterParams(isQueryParamsEnabled);
    var roomTypeFilter = roomType;
    if (queryFilterParams.roomTypes.length > 0) {
      setRoomType(queryFilterParams.roomTypes);
      roomTypeFilter = queryFilterParams.roomTypes;
    }
    loadLayoutsDebounced({
      newbuildingId: newbuildingId,
      houseId: houseId,
      roomType: roomTypeFilter,
      page: 1
    });
  }, [newbuildingId, houseId, isHouseLayoutsAvailable, isQueryParamsEnabled]);
  var onPageChange = React.useCallback(function (page) {
    setPage(page);
    loadLayoutsDebounced({
      houseId: houseId,
      newbuildingId: newbuildingId,
      roomType: roomType,
      page: page
    });
  }, [roomType, houseId, newbuildingId]);
  var onRoomTypeChange = React.useCallback(function (roomType) {
    if (isQueryParamsEnabled) {
      setRoomQueryParams(roomType);
    }
    setRoomType(roomType);
    loadLayoutsDebounced({
      houseId: houseId,
      newbuildingId: newbuildingId,
      roomType: roomType,
      page: 1
    });
  }, [houseId, newbuildingId, isQueryParamsEnabled]);
  return {
    onRoomTypeChange: onRoomTypeChange,
    layouts: layouts,
    roomType: roomType,
    isLoading: isLoading,
    onLayoutsReset: function onLayoutsReset() {
      return loadLayoutsDebounced({
        houseId: houseId,
        newbuildingId: newbuildingId,
        roomType: roomType,
        page: page
      });
    },
    isError: isError,
    offersLinks: offersLinks,
    pagination: {
      page: page,
      lastPage: lastPage,
      onPageChange: onPageChange
    }
  };
};